<ng-container
    [ngComponentOutlet]="activeComponent"
    [ngComponentOutletInputs]="{'selectedPersona': selectedPersona, 'personaTitles': personaTitles}"
></ng-container>
